document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.hasAttribute('hidden');
      menu.toggleAttribute('hidden', !open);
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-checkout-guard]').forEach((guard) => {
    const form = guard.closest('form');
    const button = form && form.querySelector('[data-checkout-button]');
    const boxes = [...guard.querySelectorAll('input[type="checkbox"]')];
    const sync = () => {
      if (button) button.disabled = !boxes.every((box) => box.checked);
    };
    boxes.forEach((box) => box.addEventListener('change', sync));
    sync();
  });
});
